import { LogbookRecordMalfunction, LogbookRecordWarning, LogRecord, LogTimers, ViolationsDto } from '@fleet-beat/api';

export interface GroupedByDriversByDateDto {
  timers?: LogTimers;
  violations: ViolationsDto[];
  warnings: LogbookRecordWarning[];
  log?: LogRecord;
  malfunctions: LogbookRecordMalfunction[];
}
